import React, { Component } from 'react';
import { TransitionMotion, spring } from 'react-motion';
import { Button, Icon } from 'b3';
import { connect } from 'react-redux';
import { cancelStackedStep } from './logActivityReducer';

var animationYDiff = 50;

const StackedStepa = ({opacity, y, cancelStackedStep, Component}) => {
	return (
		<div className="stacked-step" style={{opacity, transform: `translateY(${y}px)`}}>
			<div className="wizardScrollContainer">
				<div className="goBackWizardButtonWrapper">
					<div className="scheduled-activity-icons">
					</div>
					<Button className="goBackWizardButton" tabIndex={4} onClick={cancelStackedStep}>
					    <Icon icon="arrow-2" /> Cancel
					</Button>
				</div>
				{React.createElement(Component, {isInStackedStep: true})}
			</div>
		</div>
	);
}

var WithCancelStackStep = connect(
  state => ({}),
  { cancelStackedStep }
)(StackedStepa)

export default class StackedStep extends Component {
    render() {
        var { isOpen } = this.props;

        return (
            <TransitionMotion
                willEnter={() => ({
                    opacity: 0.5,
                    y: animationYDiff,
                })}
                willLeave={() => ({
                    opacity: spring(0, {stiffness: 150}),
                    y: spring(animationYDiff),
                })}
                styles={isOpen ? [{
                    key: 'a',
                    data: {},
                    style: {
                      opacity: spring(1),
                      y: spring(0),
                    },
                }] : []}>
            {([interpolated]) =>
                interpolated ? <WithCancelStackStep {...this.props} {...interpolated.style} /> : null
            }
            </TransitionMotion>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/StackedStep.js